function collectionGroup(html) {
  // don't do anything if this is the cookies collection as defined in deweys-main-collection-product-grid.liquid
  if (window.currentCollection !== "cookies") return

  // Get the groups from the filter so that we have correct order
  const getGroups = () => {
    const flavors = []
    const filtersForm = document.querySelector("facet-filters-form")
    const flavorsInputs = filtersForm.querySelectorAll(
      "label[for^=Filter-Flavor] input"
    )
    flavorsInputs.forEach((input) => {
      flavors.push(input.value)
    })
    flavors.push("other_flavors")
    return flavors
  }

  // Sort html products into various groups using a map so we can maintain order
  const sortProducts = (products, groups) => {
    const grouped = new Map()
    groups.forEach((group) => {
      grouped.set(group.split(",")[0], {
        items: [],
        color: group.split(",")[1],
      })
    })
    grouped.set("other_flavors", { items: [], color: "#2C2A26" })

    products.forEach((product) => {
      const key = product.dataset.flavor
        ? product.dataset.flavor.split(",")[0]
        : "other_flavors"
      if (grouped.get(key)) {
        const items = grouped.get(key).items
        items.push(product)
        const newValue = {
          items,
          color: grouped.get(key).color,
        }
        grouped.set(key, newValue)
      }
    })

    return grouped
  }

  // HTML template for header
  const groupHeaderTemplate = (label, headerColor) => {
    const groupHeader = document.createElement("div")
    const groupLabel = document.createElement("span")
    groupHeader.classList.add("products-list-box-head")
    groupHeader.style.backgroundColor = headerColor
    groupLabel.textContent = label.replace("_", " ")
    groupHeader.appendChild(groupLabel)

    return groupHeader
  }

  // HTML template for group of products
  const itemsTemplate = (items, group, headerColor) => {
    const groupWrapper = document.createElement("div")
    const itemsWrapper = document.createElement("div")
    itemsWrapper.classList.add("row")
    itemsWrapper.classList.add("row-spaceless")
    items.forEach((item) => {
      itemsWrapper.appendChild(item)
    })
    groupWrapper.appendChild(groupHeaderTemplate(group, headerColor))
    groupWrapper.appendChild(itemsWrapper)
    return groupWrapper
  }

  const products = html
    ? html.querySelectorAll(".product")
    : document.querySelectorAll(".product")
  const productGrid = html
    ? html.querySelector("#product-grid")
    : document.getElementById("product-grid")
  const flavors = getGroups(products)
  const groups = sortProducts(products, flavors)
  const groupsHTML = []

  productGrid.innerHTML = ""

  getGroups().forEach((groupString) => {
    const group = groupString.split(",")[0]
    if (groups.get(group).items.length) {
      groupsHTML.push(
        itemsTemplate(groups.get(group).items, group, groups.get(group).color)
      )
    }
  })

  groupsHTML.forEach((group) => {
    const grouping = document.createElement("div")
    grouping.appendChild(group)
    productGrid.appendChild(grouping)
  })
}

// format the filter list and remove the hex color from the string
function cleanUpFilterList() {
  const filterList = document.querySelectorAll(
    ".facets__item label[for^=Filter-Flavor], .mobile-facets__item label[for^=Filter-Flavor-mobile]"
  )
  filterList.forEach((filter) => {
    filter.querySelectorAll("span").forEach((item) => {
      item.textContent = item.textContent
        .replace(/#....../, "")
        .replace(/,/, "")
        .replace("_", " ")
    })
  })
}

// Assign to window for access within facets.js when items are updated through ajax
window.collectionGroup = collectionGroup
